module.exports = __webpack_public_path__ + "img/view-chicken-icon.b5e7abed.svg";